module.exports = __webpack_public_path__ + "img/sport-16-@1x.c5070e90.png";